var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha-holder"},[_c('vue-recaptcha',{attrs:{"sitekey":_vm.siteKey},on:{"verify":function($event){return _vm.$emit('validate', _vm.onVerify)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }